<template>
<!--    <div id="payment_container">
        <button @click="startPayment" class="button js-pay-button">Оплатить</button>
    </div>-->
    <div class="fondy-pay">
        <div id="checkout-container"></div>
    </div>
</template>
<style>
@import 'https://pay.fondy.eu/latest/checkout-vue/checkout.css';
</style>
<script>
    import { mapState } from 'vuex'

    import { mapMutations } from 'vuex'

    /* global WecanGtm */
    export default {
        mounted(){
          this.startPayment();
          let self = this;
            setTimeout(function () {
                self.sendInfoToGtm()
            }, 2000)
        },
        methods: {
            startPayment: function () {
                if (this.order && this.order.paid) {
                    this.$router.push('success');
                } else {
                    if (this.invoice) {
                        this.initPayment(this.invoice);

                        //checkout.open();
                    } else {
                        this.$router.push({
                            name: 'confirm'
                        });
                    }
                }
            },
            initPayment: function (invoice) {
                var self = this;

                // eslint-disable-next-line
                fondy('#checkout-container', invoice)
                    .$on("error", function(model) {
                        console.log("code:" + model.attr('error.code'))
                        console.log("errorMsg:" + model.attr('error.message'))
                        var close = document.getElementsByClassName("f-close");
                        for (var i = 0; i < close.length; i++) {
                            close[i].addEventListener('click', function () {
                                self.$router.push({
                                    name: 'confirm',
                                })
                            })
                        }
                    })
                    .$on('success', function (model) {
                        var orderStatus = model.attr("order.order_data.order_status");
                        if (orderStatus === "approved") {
                            self.$router.push({
                                name: 'success'
                            });
                        } else {
                            self.$router.push({
                                name: 'success'
                            });
                        }
                    });
            },
            sendInfoToGtm: function () {
                if (typeof this.order !== "undefined" && typeof WecanGtm !== "undefined") {
                    WecanGtm.checkout(
                        this.currentEvent.name,
                        this.currentEvent.direction_id,
                        this.currentEvent.price,
                        process.env.VUE_APP_GTM_CATEGORY,
                        'N/A',
                        this.order.person_count,
                        this.currentEvent.currency
                    )
                }
            },
            ...mapMutations([
                'setIsOverdueTime'
            ])
        },
        computed: {
            ...mapState([
                'invoice',
                'order',
                'currentEvent',
                'overdueTime',
                'isOverdueTime',
                'currentEventId',
          ])
        }
    }
</script>
<style scoped="scoped">
  .component {
    display: none;
  }
    #payment_container {
        margin: 100px auto;
        width: 250px;
    }
</style>
